import { setRangeMax } from './helpers';

export const setLandAreaMax = setRangeMax('site');
